import { render, staticRenderFns } from "./ThirdStepWizzard.vue?vue&type=template&id=582c386d&scoped=true&"
import script from "./ThirdStepWizzard.vue?vue&type=script&lang=js&"
export * from "./ThirdStepWizzard.vue?vue&type=script&lang=js&"
import style0 from "./ThirdStepWizzard.vue?vue&type=style&index=0&id=582c386d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582c386d",
  null
  
)

export default component.exports